module.exports = __webpack_public_path__ + "media/houseWithLessHills.af5a7c7c.png";